import React, { CSSProperties, useState } from 'react';

import Box from '@cobalt/react-box';
import Flex from '@cobalt/react-flex';

import { findListByParentId } from '../treeUtil';

import CascaderItem from './CascaderItem';
import { CascaderSelectOptionType } from '../types';

export interface CascaderItemProps {
  selectedValue: string[];
  options: CascaderSelectOptionType[];
  style?: CSSProperties;
  onChangeSelect: (value: string, level: number, isLastLevel?: boolean) => void;
}

const CascaderListor = (props: CascaderItemProps) => {
  const { onChangeSelect, selectedValue, options, style } = props;
  const [left, setLeft] = useState(selectedValue.length > 1 ? `-${(selectedValue.length - 1) * 100}%` : '0%');
  const [curLevel, setCurLevel] = useState(selectedValue.length || 1);

  const onBack = (level: number) => {
    setLeft(`-${(level - 2) * 100}%`);
    onChangeSelect('', level);
    setCurLevel(level - 1);
  };

  const onSelect = (value: string, level: number) => {
    if (findListByParentId(options, value).length > 0) {
      onChangeSelect(value, level, false);
      setLeft(`-${(level || 0) * 100}%`);
      setCurLevel(level! + 1);
    } else {
      onChangeSelect(value, level, true);
    }
  };

  return (
    <Box
      data-testid="cascaderListor"
      scrollable
      style={{ width: '300%', position: 'relative', transition: 'left 0.2s ease 0s', left }}
    >
      {/* Option list */}
      <Flex>
        {[1, 2, 3].map((level) => (
          <Box key={level} width="100%" padding={2} style={{ overflowX: 'hidden', ...style }}>
            {curLevel === level && (
              <CascaderItem
                {...props}
                options={
                  level === 1 ? findListByParentId(options, '0') : findListByParentId(options, selectedValue[level - 2])
                }
                level={level}
                onBack={onBack}
                onChangeSelect={onSelect}
                selectedValue={selectedValue[level - 1]}
              />
            )}
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default CascaderListor;
